import { createBootstrap } from "../../bootstrap";

export default createBootstrap("recipients", "institution");
